import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HeroSection.css';
import AnnouncementBanner from '../pages/AnnouncementBanner';

const HeroSection = () => {
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ 
        position: 'relative',
        top: '80px',
        left: 0,
        right: 0,
        zIndex: 10
      }}>
        <AnnouncementBanner />
      </div>
      <section className="hero">
        <div className="hero-content">
          <h1>Where Charitable Ideas Find Their Foundation</h1>
          <p>
          Cause and Impact provides the 501(c)(3) foundation and fully manages the compliance, finances, and administration, so you can focus entirely on your mission
          </p>
          <div className="hero-buttons">
            <Link to="/apply" className="hero-btn hero-btn-primary">
              Apply Now
            </Link>
            <Link to="/donate" className="hero-btn hero-btn-secondary">
              Donate Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
